import { useState } from "react";
import { Bell, X } from "lucide-react";
import { Link } from "react-router-dom";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { usePWAInstall } from "@/hooks/usePWAInstall";

const KEY = "eyfc_push_prompt_dismissed";

// Gentle one-time nudge for installed-app users who haven't enabled push yet.
export function PushPromptBanner() {
  const { isInstalled } = usePWAInstall();
  const { status, enable } = usePushNotifications();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden || !isInstalled || status !== "off") return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="fixed bottom-24 md:bottom-4 left-1/2 -translate-x-1/2 z-[55] w-[calc(100%-2rem)] max-w-md" data-testid="push-prompt-banner">
      <div className="rounded-md border border-border bg-[#0A0F1C] text-white shadow-2xl p-4 flex items-center gap-3">
        <Bell className="w-5 h-5 text-[#83B68B] flex-shrink-0" />
        <div className="flex-1 min-w-0 text-xs">
          <div className="font-display font-bold text-sm">Turn on phone alerts?</div>
          <div className="opacity-70">Know instantly when a booking or fixture changes. <Link to="/app/account" className="underline">Manage</Link></div>
        </div>
        <button type="button" onClick={async () => { const ok = await enable(); if (ok) dismiss(); }} data-testid="push-prompt-enable" className="btn-volt px-3 py-2 rounded text-[10px] tracking-widest uppercase">Enable</button>
        <button type="button" onClick={dismiss} data-testid="push-prompt-dismiss" className="p-1 opacity-60 hover:opacity-100"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
